import type {
	Brain, BrainContentCount, BrainWithCounts, ContentUploadStatus, IntegrationWithContentCount
} from '@types'
import axios from 'axios'

import type { UserBrain } from 'libs/types/src/user-brain'

import env from '../environments'

export const DRAG_AND_DROP_BRAIN_NAME = 'VirtualBrain - Applications'

export async function createBrain(name: string) {
	const response = await axios.post(`${env.apiUrl}/brains/create`, {
		name
	})

	return response.data as Brain
}

export async function getBrain(id: string) {
	const response = await axios.get(`${env.apiUrl}/brains/${id}`)

	return response.data as BrainWithCounts
}

export async function getBrains(accessToken?: string | undefined) {
	let headers

	if (accessToken) {
		headers = {
		// eslint-disable-next-line @typescript-eslint/naming-convention
			Authorization: 'Bearer ' + accessToken
		}
	}

	const response = await axios.get(env.apiUrl + '/brains', {
		headers
	})

	return response.data as Brain[]
}

export interface GetBrainContentsOptions {
	offset?: number | undefined;
	limit?: number | undefined;
	status?: ContentUploadStatus | undefined;
}

export async function getBrainContents(id: string, { offset, limit, status }: GetBrainContentsOptions = {}) {
	const response = await axios.get(`${env.apiUrl}/brains/${id}/contents`, {
		params: {
			offset,
			limit,
			status
		}
	})

	return response.data as BrainContentCount
}

export async function getBrainIntegrationsContentsCount(id: string) {
	const response = await axios.get(`${env.apiUrl}/brains/${id}/integrations/contents/count`)

	return response.data as IntegrationWithContentCount[]
}

export async function updateBrain(id: string, updatedBrain: Partial<Brain>) {
	const response = await axios.put(`${env.apiUrl}/brains/${id}`, updatedBrain)

	return response.data as Brain
}

export async function getEmptyBrains(ids: string[]) {
	const response = await axios.post(
		`${env.apiUrl}/brains/emptybrains`,
		{ brainsIds: ids }
	)

	return response.data as boolean[]
}

export async function deleteBrain(id: string) {
	return axios.delete(`${env.apiUrl}/brains/${id}`)
}

export async function getBrainUsers(id: string) {
	const response = await axios.get(`${env.apiUrl}/brains/sharedWith/${id}`)

	return response.data as UserBrain[]
}
